/**
 * @fileoverview GET handler for the "/app_settings/api_key_details/:api_key" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { appSettingsApiKeyDetailsApiKey } from "./constants";
import type { GetApiKeyDetailsResult } from "./types";

export const getApiKeyDetails = reactQueryFetcherAdapter(
  appSettingsApiKeyDetailsApiKey,
  (signal: AbortSignal, apiKey: string): Promise<GetApiKeyDetailsResult> => {
    return fetch(`/app_settings/api_key_details/${apiKey}`, "GET", {}, { signal });
  }
);
